const FEATURES = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '高清离线下载',
    desc: '支持高清画质一键下载到本地，无网络也能畅快阅读，旅途中再也不怕断网无聊。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '智能追更提醒',
    desc: '关注的漫画一有更新即刻推送通知，不错过任何精彩章节，追更体验无缝衔接。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量免费全集',
    desc: '日漫韩漫国漫一网打尽，从经典老番到新番连载，全部免费畅读无需付费解锁。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步阅读',
    desc: '手机、平板、电脑阅读进度实时同步，切换设备无缝续读，随时随地继续你的漫画之旅。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '个性化收藏夹',
    desc: '自由创建分类收藏夹，按喜好整理心爱漫画，打造专属于你的私人漫画图书馆。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            为什么漫画迷都选择樱花漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-colors cursor-default"
            >
              <div className="w-11 h-11 mb-4 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}